export default __webpack_public_path__ + "static/media/green-leaf.b60effb4.svg";